// Arquivo do CRUD de bookings
import { useState, useEffect } from 'react'
import { Container } from "./styles"
import { api } from "../../../services/api"
import Select from "../../../components/Select"
import {alert} from "../../../components/Alert"

const BookingsConfirm = () => {

  const [bookings, setBookings] = useState([]);

  const options = [{value: "Aprovado", label: "Aprovado"}, {value: "Cancelado", label: "Cancelado"}, {value: "Pendente", label: "Pendente"}]

  useEffect(() => {
    api.get('bookings/index')
    .then((response) => {setBookings(response.data)})
  },[])


  const formatDate = (dateInput) => {
    let d = new Date(dateInput)
    let ye = new Intl.DateTimeFormat('pt-br', { year: 'numeric' }).format(d);
    let mo = new Intl.DateTimeFormat('pt-br', { month: 'long' }).format(d);
    let da = new Intl.DateTimeFormat('pt-br', { day: '2-digit' }).format(d);
    return(`${da} de ${mo} de ${ye}`);
  }

  const formatCPF = (cpfInput) => {
    let cpf = cpfInput.toString()
    return (cpf.substring(0,3)+'.'+cpf.substring(3,6)+'.'+cpf.substring(6,9)+'-'+cpf.substring(9,10))
  }

  const addBookings = (e, booking) => {
    if (window.confirm ("Deseja modificar o status da reserva " + booking.id + "?")){
      api.put('bookings/update/'+booking.id, {
        booking: {
          status: e.value
        }
      }).then((response) => {
        if (response.data){
          response.status===200 ? alert("Atualizado com Sucesso!", 'success') : alert("Erro: Tente Novamente", 'error')
        } else {
          alert("Erro: Tente Novamente", 'error')
        }
      })
    }
  }

    return (
        <Container>
          <p className='title'>Confirmar Reservas</p>

          <table>
            <thead>
              <tr>
                <td>Id</td>
                <td>Ínicio</td>
                <td>Fim</td>
                <td>CPF Cliente</td>
                <td>Quarto</td>
                <td>Status</td>
              </tr>
            </thead>
            <tbody>
              {bookings.map((booking, index) => { return(
                <tr key={booking.id}>
                  <td>{booking.id}</td>
                  <td>{formatDate(booking.start_time)}</td>
                  <td>{formatDate(booking.end_time)}</td>
                  <td>{formatCPF(booking.client.cpf)}</td>
                  <td>{booking.room_type.name}</td>
                  <td>
                    <Select options={options} placeholder="Status"
                    value={options.find(item => item.value === booking.status)} 
                    onChange={(e)=>{addBookings(e, booking)}}>
                    </Select>
                  </td>
                </tr>
              )})}
            </tbody>

          </table>
        </Container>
    )
}

export default BookingsConfirm
